// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3-7hv","title":"Info_title__2xpOO","selects":"Info_selects__15aZB","requiredAsterisk":"Info_requiredAsterisk__1kN6d"};